import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import { NumberRecordProperty, UUID } from '@indigohive/cogfy-types'
import type { UpdateRecordPropertiesOperationData } from '@indigohive/cogfy-types/endpoints/transactions'
import { useEffect, useState } from 'react'
import clsx from 'clsx'

export type NumberRecordPropertyInputProps = {
  collectionId: UUID
  field: Extract<GetCollectionFieldsResultData, { type: 'number' }>
  record: GetRecordByIdResult
  onUpdateRecordProperties?: (data: UpdateRecordPropertiesOperationData) => void
  disabled?: boolean
  stale?: boolean
  error?: boolean
}

export function NumberRecordPropertyInput (props: NumberRecordPropertyInputProps) {
  const { collectionId, field, record, disabled, stale, error } = props

  const property = record.properties[field.id] as NumberRecordProperty | undefined
  const number = property?.number?.value

  const [value, setValue] = useState(number ?? '')

  useEffect(() => {
    setValue(number ?? '')
  }, [record])

  const sendValue = (value: string | number) => {
    props.onUpdateRecordProperties?.({
      recordId: record.id,
      collectionId,
      properties: {
        [field.id]: {
          type: 'number',
          number: {
            value: value || null
          }
        }
      }
    })
  }

  return (
    <div>
      <input
        type="number"
        disabled={disabled}
        className={clsx(
          'input input-sm w-full',
          (stale || error) && '!border-none',
          (stale && !error) && 'custom-bg-stale',
          error && 'custom-bg-error')}
        value={value}
        onChange={event => { setValue(event.target.value) }}
        onKeyDown={event => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            sendValue(value)
          }
        }}
        onBlur={() => sendValue(value)}
      />
    </div>
  )
}
